import { Chip } from '@mui/material';

import styles from '../styles';

type VerdictChipProps = {
  value: boolean | null;
};

const VerdictChip = ({ value }: VerdictChipProps) => {
  if (value === null || value === undefined) {
    return <span>-</span>;
  }

  return (
    <Chip
      size='small'
      label={value ? 'YES' : 'NO'}
      color={value ? 'success' : 'error'}
      sx={styles.verdictChip}
    />
  );
};

export default VerdictChip;
